<!-- mospina 19-10-26 EPT-2103 Avisos institucionales dentro del sistema -->

<!-- Noticias: abajo a la derecha, una a la vez con paginador -->
<ng-container *ngFor="let a of noticiaVisible; trackBy: trackAviso">
<div class="avs-noticia" [class.avs-noticia--saliendo]="saliendo" role="status" aria-live="polite">
  <div class="avs-noticia__cabecera">
    <span class="avs-noticia__icono"><i class="bx bx-broadcast"></i></span>
    <div class="avs-noticia__meta">
      <span class="avs-noticia__tipo">Aviso general</span>
      <span class="avs-noticia__vigencia">Vigente hasta {{ a.venceMs | date:'dd/MM/yyyy' }}</span>
    </div>
    <button type="button" class="avs-cerrar" (click)="despedir(a, 'cerrar')" aria-label="Cerrar">
      <i class="bx bx-x"></i>
    </button>
  </div>

  <div class="avs-noticia__cuerpo">
    <h6 class="avs-titulo" *ngIf="a.titulo">{{ a.titulo }}</h6>
    <p class="avs-texto">{{ a.texto }}</p>
  </div>

  <div class="avs-noticia__pie">
    <div class="avs-paginador" *ngIf="noticias.length > 1">
      <button type="button" (click)="anterior()" aria-label="Anterior"><i class="bx bx-chevron-left"></i></button>
      <span>{{ indice + 1 }} de {{ noticias.length }}</span>
      <button type="button" (click)="siguiente()" aria-label="Siguiente"><i class="bx bx-chevron-right"></i></button>
    </div>
    <button type="button" class="avs-btn" (click)="despedir(a, 'leer')">
      <i class="bx bx-check"></i> Entendido
    </button>
  </div>
</div>
</ng-container>

<!-- Mantenimiento: cápsula flotante abajo al centro con cuenta regresiva -->
<div class="avs-capsula" *ngIf="mantenimiento" role="status">
  <span class="avs-capsula__icono"><i class="bx bx-wrench"></i></span>
  <p class="avs-capsula__texto">
    <strong>Mantenimiento programado</strong> · {{ mantenimiento.titulo ? mantenimiento.titulo + ' — ' + mantenimiento.texto : mantenimiento.texto }}
  </p>
  <div class="avs-digitos" *ngIf="cuenta" aria-label="Tiempo restante">
    <span *ngIf="cuenta.d">{{ cuenta.d }}<small>D</small></span>
    <span>{{ cuenta.h }}<small>H</small></span>
    <span>{{ cuenta.m }}<small>MIN</small></span>
    <span>{{ cuenta.s }}<small>SEG</small></span>
  </div>
  <button type="button" class="avs-cerrar" (click)="cerrar(mantenimiento)" aria-label="Ocultar">
    <i class="bx bx-x"></i>
  </button>
</div>

<!-- Crítico: ventana centrada -->
<div class="avs-capa" *ngIf="critico">
  <div class="avs-ventana" role="alertdialog" aria-modal="true" aria-labelledby="avsTituloCritico">
    <div class="avs-ventana__cabecera">
      <span class="avs-ventana__icono"><i class="bx bx-error"></i></span>
      <small>Aviso importante</small>
      <h5 id="avsTituloCritico">{{ critico.titulo || 'Información importante' }}</h5>
    </div>
    <div class="avs-ventana__cuerpo">
      <p>{{ critico.texto }}</p>
      <button type="button" class="avs-btn avs-btn--oscuro" (click)="marcarLeido(critico)">
        <i class="bx bx-check"></i> Entendido
      </button>
      <span class="avs-ventana__nota">Este aviso quedará registrado como leído.</span>
    </div>
  </div>
</div>
